export default __webpack_public_path__ + "static/media/company.17a7b5fa.png";